import { render, staticRenderFns } from "./temporary.vue?vue&type=template&id=510c3a3a"
import script from "./temporary.vue?vue&type=script&lang=js"
export * from "./temporary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports